// import Immutable from "seamless-immutable";
const mainState = {
  menuHoverIndex: 0,
  menuActiveIndex: 0,
  menuIsHovering: false,
  isOpenModalGallery: false,
  galleryItems: [],
  galleryTitle: null,
};

export default mainState;
